import api from "@/config/api"
import { withLoading } from "@/store/helpers"

export default {
  namespaced: true,
  state: () => ({
    teams: [],
    loading: false,
    // Мутации держат свой флаг: `loading` подменяет всю вкладку лоадером,
    // и форма создания вместе с ней исчезала до ответа сервера.
    saving: false,
  }),
  mutations: {
    setTeams(state, teams) {
      state.teams = teams
    },
    setLoading(state, loading) {
      state.loading = loading
    },
    setSaving(state, saving) {
      state.saving = saving
    }
  },
  actions: {
    async fetchTeams(context) {
      return withLoading(async () => {
        try {
          const response = await api.get("/manage/teams")
          context.commit("setTeams", response.data)
        } catch (error) {
          // Отказ загрузки — пустой список: экран показывает «Команды не найдены»
          // вместо таблицы с одной шапкой.
          context.commit("setTeams", [])
        }
      }, context)
    },

    async createTeam(context, params) {
      context.commit("setSaving", true)

      try {
        const response = await api.post("/manage/teams", params)
        context.commit("setTeams", response.data)
      } finally {
        context.commit("setSaving", false)
      }
    },

    async deleteTeam(context, id) {
      context.commit("setSaving", true)

      try {
        const response = await api.delete(`/manage/teams/${id}`)
        context.commit("setTeams", response.data)
      } finally {
        context.commit("setSaving", false)
      }
    },

    async updateTeam(context, { id, ...params }) {
      context.commit("setSaving", true)

      try {
        const response = await api.put(`/manage/teams/${id}`, params)
        context.commit("setTeams", response.data)
      } finally {
        context.commit("setSaving", false)
      }
    }
  }
}
